<template>
  <div class="about">
    <div class="container">
      <div>
        <Title />
        <div class="row justify-content-between">
          <Breadcrumb />
          <div class="col-12 col-sm text-end mb-3 mb-sm-0">
            <button
              type="button"
              class="btn btn-transparent me-3"
              @click="getAboutDate"
            >
              取消
            </button>
            <button type="button" @click="save" class="btn btn-light">
              儲存
            </button>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-body">
          <quill v-model="content" />
        </div>
      </div>
      <div class="text-end mb-3">
        <button
          type="button"
          class="btn btn-secondary me-3"
          @click="getAboutDate"
        >
          取消
        </button>
        <button type="button" @click="save" class="btn btn-gradient">
          儲存
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { onePage } from '@/http/api/onePage.js'
import { mapState, mapGetters, mapMutations } from 'vuex'
import quill from '@/components/plugin/Quill.vue'
import Title from '@/components/layout/Title.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'

export default {
  name: 'About',
  components: { quill, Title, Breadcrumb },
  data () {
    return {
      content: null,
      errMsgKey: {
        content: '關於我們'
      }
    }
  },
  computed: {
    ...mapState(['token']),
    ...mapGetters(['errMsgInfo'])
  },
  watch: {
    'token.headers.Authorization': function (data) {
      if (data) {
        this.initialEvent()
      }
    }
  },
  methods: {
    ...mapMutations([
      'Loading',
      'Loaded',
      'AlertsInfo',
      'Alerted',
      'SetRouterName',
      'SetErrMsg',
      'SetErrMsgKey'
    ]),
    getAboutDate () {
      const vm = this
      vm.Loading()
      onePage
        .getAbout(vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.content = data.data.content
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '錯誤',
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '錯誤',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    initialEvent () {
      const vm = this
      vm.getAboutDate()
    },
    save () {
      const vm = this
      vm.Loading()
      vm.updateAbout()
    },
    updateAbout () {
      const vm = this
      onePage
        .updateAbout({ content: vm.content }, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '更新資料成功'
            })
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    }
  },
  created () {
    const vm = this
    vm.SetRouterName(vm.$route.name)
    vm.SetErrMsgKey(vm.errMsgKey)
  },
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.initialEvent()
    }
  }
}
</script>
